import localeafNA from '@angular/common/locales/af-NA';
import localeaf from '@angular/common/locales/af';
import localeagq from '@angular/common/locales/agq';
import localeak from '@angular/common/locales/ak';
import localeam from '@angular/common/locales/am';
import localearAE from '@angular/common/locales/ar-AE';
import localearBH from '@angular/common/locales/ar-BH';
import localearDJ from '@angular/common/locales/ar-DJ';
import localearDZ from '@angular/common/locales/ar-DZ';
import localearEG from '@angular/common/locales/ar-EG';
import localearEH from '@angular/common/locales/ar-EH';
import localearER from '@angular/common/locales/ar-ER';
import localearIL from '@angular/common/locales/ar-IL';
import localearIQ from '@angular/common/locales/ar-IQ';
import localearJO from '@angular/common/locales/ar-JO';
import localearKM from '@angular/common/locales/ar-KM';
import localearKW from '@angular/common/locales/ar-KW';
import localearLB from '@angular/common/locales/ar-LB';
import localearLY from '@angular/common/locales/ar-LY';
import localearMA from '@angular/common/locales/ar-MA';
import localearMR from '@angular/common/locales/ar-MR';
import localearOM from '@angular/common/locales/ar-OM';
import localearPS from '@angular/common/locales/ar-PS';
import localearQA from '@angular/common/locales/ar-QA';
import localearSA from '@angular/common/locales/ar-SA';
import localearSD from '@angular/common/locales/ar-SD';
import localearSO from '@angular/common/locales/ar-SO';
import localearSS from '@angular/common/locales/ar-SS';
import localearSY from '@angular/common/locales/ar-SY';
import localearTD from '@angular/common/locales/ar-TD';
import localearTN from '@angular/common/locales/ar-TN';
import localearYE from '@angular/common/locales/ar-YE';
import localear from '@angular/common/locales/ar';
import localeas from '@angular/common/locales/as';
import localeasa from '@angular/common/locales/asa';
import localeast from '@angular/common/locales/ast';
import localeazCyrl from '@angular/common/locales/az-Cyrl';
import localeazLatn from '@angular/common/locales/az-Latn';
import localeaz from '@angular/common/locales/az';
import localebas from '@angular/common/locales/bas';
import localebe from '@angular/common/locales/be';
import localebem from '@angular/common/locales/bem';
import localebez from '@angular/common/locales/bez';
import localebg from '@angular/common/locales/bg';
import localebm from '@angular/common/locales/bm';
import localebnIN from '@angular/common/locales/bn-IN';
import localebn from '@angular/common/locales/bn';
import localeboIN from '@angular/common/locales/bo-IN';
import localebo from '@angular/common/locales/bo';
import localebr from '@angular/common/locales/br';
import localebrx from '@angular/common/locales/brx';
import localebsCyrl from '@angular/common/locales/bs-Cyrl';
import localebsLatn from '@angular/common/locales/bs-Latn';
import localebs from '@angular/common/locales/bs';
import localecaAD from '@angular/common/locales/ca-AD';
import localecaFR from '@angular/common/locales/ca-FR';
import localecaIT from '@angular/common/locales/ca-IT';
import localeca from '@angular/common/locales/ca';
import localeccpIN from '@angular/common/locales/ccp-IN';
import localeccp from '@angular/common/locales/ccp';
import localece from '@angular/common/locales/ce';
import localecgg from '@angular/common/locales/cgg';
import localechr from '@angular/common/locales/chr';
import localeckbIR from '@angular/common/locales/ckb-IR';
import localeckb from '@angular/common/locales/ckb';
import localecs from '@angular/common/locales/cs';
import localecy from '@angular/common/locales/cy';
import localedaGL from '@angular/common/locales/da-GL';
import localeda from '@angular/common/locales/da';
import localedav from '@angular/common/locales/dav';
import localedeAT from '@angular/common/locales/de-AT';
import localedeBE from '@angular/common/locales/de-BE';
import localedeCH from '@angular/common/locales/de-CH';
import localedeIT from '@angular/common/locales/de-IT';
import localedeLI from '@angular/common/locales/de-LI';
import localedeLU from '@angular/common/locales/de-LU';
import localede from '@angular/common/locales/de';
import localedje from '@angular/common/locales/dje';
import localedsb from '@angular/common/locales/dsb';
import localedua from '@angular/common/locales/dua';
import localedyo from '@angular/common/locales/dyo';
import localedz from '@angular/common/locales/dz';
import localeebu from '@angular/common/locales/ebu';
import localeeeTG from '@angular/common/locales/ee-TG';
import localeee from '@angular/common/locales/ee';
import localeelCY from '@angular/common/locales/el-CY';
import localeel from '@angular/common/locales/el';
import localeen001 from '@angular/common/locales/en-001';
import localeen150 from '@angular/common/locales/en-150';
import localeenAG from '@angular/common/locales/en-AG';
import localeenAI from '@angular/common/locales/en-AI';
import localeenAS from '@angular/common/locales/en-AS';
import localeenAT from '@angular/common/locales/en-AT';
import localeenAU from '@angular/common/locales/en-AU';
import localeenBB from '@angular/common/locales/en-BB';
import localeenBE from '@angular/common/locales/en-BE';
import localeenBI from '@angular/common/locales/en-BI';
import localeenBM from '@angular/common/locales/en-BM';
import localeenBS from '@angular/common/locales/en-BS';
import localeenBW from '@angular/common/locales/en-BW';
import localeenBZ from '@angular/common/locales/en-BZ';
import localeenCA from '@angular/common/locales/en-CA';
import localeenCC from '@angular/common/locales/en-CC';
import localeenCH from '@angular/common/locales/en-CH';
import localeenCK from '@angular/common/locales/en-CK';
import localeenCM from '@angular/common/locales/en-CM';
import localeenCX from '@angular/common/locales/en-CX';
import localeenCY from '@angular/common/locales/en-CY';
import localeenDE from '@angular/common/locales/en-DE';
import localeenDG from '@angular/common/locales/en-DG';
import localeenDK from '@angular/common/locales/en-DK';
import localeenDM from '@angular/common/locales/en-DM';
import localeenER from '@angular/common/locales/en-ER';
import localeenFI from '@angular/common/locales/en-FI';
import localeenFJ from '@angular/common/locales/en-FJ';
import localeenFK from '@angular/common/locales/en-FK';
import localeenFM from '@angular/common/locales/en-FM';
import localeenGB from '@angular/common/locales/en-GB';
import localeenGD from '@angular/common/locales/en-GD';
import localeenGG from '@angular/common/locales/en-GG';
import localeenGH from '@angular/common/locales/en-GH';
import localeenGI from '@angular/common/locales/en-GI';
import localeenGM from '@angular/common/locales/en-GM';
import localeenGU from '@angular/common/locales/en-GU';
import localeenGY from '@angular/common/locales/en-GY';
import localeenHK from '@angular/common/locales/en-HK';
import localeenIE from '@angular/common/locales/en-IE';
import localeenIL from '@angular/common/locales/en-IL';
import localeenIM from '@angular/common/locales/en-IM';
import localeenIN from '@angular/common/locales/en-IN';
import localeenIO from '@angular/common/locales/en-IO';
import localeenJE from '@angular/common/locales/en-JE';
import localeenJM from '@angular/common/locales/en-JM';
import localeenKE from '@angular/common/locales/en-KE';
import localeenKI from '@angular/common/locales/en-KI';
import localeenKN from '@angular/common/locales/en-KN';
import localeenKY from '@angular/common/locales/en-KY';
import localeenLC from '@angular/common/locales/en-LC';
import localeenLR from '@angular/common/locales/en-LR';
import localeenLS from '@angular/common/locales/en-LS';
import localeenMG from '@angular/common/locales/en-MG';
import localeenMH from '@angular/common/locales/en-MH';
import localeenMO from '@angular/common/locales/en-MO';
import localeenMP from '@angular/common/locales/en-MP';
import localeenMS from '@angular/common/locales/en-MS';
import localeenMT from '@angular/common/locales/en-MT';
import localeenMU from '@angular/common/locales/en-MU';
import localeenMW from '@angular/common/locales/en-MW';
import localeenMY from '@angular/common/locales/en-MY';
import localeenNA from '@angular/common/locales/en-NA';
import localeenNF from '@angular/common/locales/en-NF';
import localeenNG from '@angular/common/locales/en-NG';
import localeenNL from '@angular/common/locales/en-NL';
import localeenNR from '@angular/common/locales/en-NR';
import localeenNU from '@angular/common/locales/en-NU';
import localeenNZ from '@angular/common/locales/en-NZ';
import localeenPG from '@angular/common/locales/en-PG';
import localeenPH from '@angular/common/locales/en-PH';
import localeenPK from '@angular/common/locales/en-PK';
import localeenPN from '@angular/common/locales/en-PN';
import localeenPR from '@angular/common/locales/en-PR';
import localeenPW from '@angular/common/locales/en-PW';
import localeenRW from '@angular/common/locales/en-RW';
import localeenSB from '@angular/common/locales/en-SB';
import localeenSC from '@angular/common/locales/en-SC';
import localeenSD from '@angular/common/locales/en-SD';
import localeenSE from '@angular/common/locales/en-SE';
import localeenSG from '@angular/common/locales/en-SG';
import localeenSH from '@angular/common/locales/en-SH';
import localeenSI from '@angular/common/locales/en-SI';
import localeenSL from '@angular/common/locales/en-SL';
import localeenSS from '@angular/common/locales/en-SS';
import localeenSX from '@angular/common/locales/en-SX';
import localeenSZ from '@angular/common/locales/en-SZ';
import localeenTC from '@angular/common/locales/en-TC';
import localeenTK from '@angular/common/locales/en-TK';
import localeenTO from '@angular/common/locales/en-TO';
import localeenTT from '@angular/common/locales/en-TT';
import localeenTV from '@angular/common/locales/en-TV';
import localeenTZ from '@angular/common/locales/en-TZ';
import localeenUG from '@angular/common/locales/en-UG';
import localeenUM from '@angular/common/locales/en-UM';
import localeenVC from '@angular/common/locales/en-VC';
import localeenVG from '@angular/common/locales/en-VG';
import localeenVI from '@angular/common/locales/en-VI';
import localeenVU from '@angular/common/locales/en-VU';
import localeenWS from '@angular/common/locales/en-WS';
import localeenZA from '@angular/common/locales/en-ZA';
import localeenZM from '@angular/common/locales/en-ZM';
import localeenZW from '@angular/common/locales/en-ZW';
import localeen from '@angular/common/locales/en';
import localeeo from '@angular/common/locales/eo';
import localees419 from '@angular/common/locales/es-419';
import localeesAR from '@angular/common/locales/es-AR';
import localeesBO from '@angular/common/locales/es-BO';
import localeesBR from '@angular/common/locales/es-BR';
import localeesBZ from '@angular/common/locales/es-BZ';
import localeesCL from '@angular/common/locales/es-CL';
import localeesCO from '@angular/common/locales/es-CO';
import localeesCR from '@angular/common/locales/es-CR';
import localeesCU from '@angular/common/locales/es-CU';
import localeesDO from '@angular/common/locales/es-DO';
import localeesEA from '@angular/common/locales/es-EA';
import localeesEC from '@angular/common/locales/es-EC';
import localeesGQ from '@angular/common/locales/es-GQ';
import localeesGT from '@angular/common/locales/es-GT';
import localeesHN from '@angular/common/locales/es-HN';
import localeesIC from '@angular/common/locales/es-IC';
import localeesMX from '@angular/common/locales/es-MX';
import localeesNI from '@angular/common/locales/es-NI';
import localeesPA from '@angular/common/locales/es-PA';
import localeesPE from '@angular/common/locales/es-PE';
import localeesPH from '@angular/common/locales/es-PH';
import localeesPR from '@angular/common/locales/es-PR';
import localeesPY from '@angular/common/locales/es-PY';
import localeesSV from '@angular/common/locales/es-SV';
import localeesUS from '@angular/common/locales/es-US';
import localeesUY from '@angular/common/locales/es-UY';
import localeesVE from '@angular/common/locales/es-VE';
import localees from '@angular/common/locales/es';
import localeet from '@angular/common/locales/et';
import localeeu from '@angular/common/locales/eu';
import localeewo from '@angular/common/locales/ewo';
import localefaAF from '@angular/common/locales/fa-AF';
import localefa from '@angular/common/locales/fa';
import localeffCM from '@angular/common/locales/ff-CM';
import localeffGN from '@angular/common/locales/ff-GN';
import localeffMR from '@angular/common/locales/ff-MR';
import localeff from '@angular/common/locales/ff';
import localefi from '@angular/common/locales/fi';
import localefil from '@angular/common/locales/fil';
import localefoDK from '@angular/common/locales/fo-DK';
import localefo from '@angular/common/locales/fo';
import localefrBE from '@angular/common/locales/fr-BE';
import localefrBF from '@angular/common/locales/fr-BF';
import localefrBI from '@angular/common/locales/fr-BI';
import localefrBJ from '@angular/common/locales/fr-BJ';
import localefrBL from '@angular/common/locales/fr-BL';
import localefrCA from '@angular/common/locales/fr-CA';
import localefrCD from '@angular/common/locales/fr-CD';
import localefrCF from '@angular/common/locales/fr-CF';
import localefrCG from '@angular/common/locales/fr-CG';
import localefrCH from '@angular/common/locales/fr-CH';
import localefrCI from '@angular/common/locales/fr-CI';
import localefrCM from '@angular/common/locales/fr-CM';
import localefrDJ from '@angular/common/locales/fr-DJ';
import localefrDZ from '@angular/common/locales/fr-DZ';
import localefrGA from '@angular/common/locales/fr-GA';
import localefrGF from '@angular/common/locales/fr-GF';
import localefrGN from '@angular/common/locales/fr-GN';
import localefrGP from '@angular/common/locales/fr-GP';
import localefrGQ from '@angular/common/locales/fr-GQ';
import localefrHT from '@angular/common/locales/fr-HT';
import localefrKM from '@angular/common/locales/fr-KM';
import localefrLU from '@angular/common/locales/fr-LU';
import localefrMA from '@angular/common/locales/fr-MA';
import localefrMC from '@angular/common/locales/fr-MC';
import localefrMF from '@angular/common/locales/fr-MF';
import localefrMG from '@angular/common/locales/fr-MG';
import localefrML from '@angular/common/locales/fr-ML';
import localefrMQ from '@angular/common/locales/fr-MQ';
import localefrMR from '@angular/common/locales/fr-MR';
import localefrMU from '@angular/common/locales/fr-MU';
import localefrNC from '@angular/common/locales/fr-NC';
import localefrNE from '@angular/common/locales/fr-NE';
import localefrPF from '@angular/common/locales/fr-PF';
import localefrPM from '@angular/common/locales/fr-PM';
import localefrRE from '@angular/common/locales/fr-RE';
import localefrRW from '@angular/common/locales/fr-RW';
import localefrSC from '@angular/common/locales/fr-SC';
import localefrSN from '@angular/common/locales/fr-SN';
import localefrSY from '@angular/common/locales/fr-SY';
import localefrTD from '@angular/common/locales/fr-TD';
import localefrTG from '@angular/common/locales/fr-TG';
import localefrTN from '@angular/common/locales/fr-TN';
import localefrVU from '@angular/common/locales/fr-VU';
import localefrWF from '@angular/common/locales/fr-WF';
import localefrYT from '@angular/common/locales/fr-YT';
import localefr from '@angular/common/locales/fr';
import localefur from '@angular/common/locales/fur';
import localefy from '@angular/common/locales/fy';
import localega from '@angular/common/locales/ga';
import localegd from '@angular/common/locales/gd';
import localegl from '@angular/common/locales/gl';
import localegswFR from '@angular/common/locales/gsw-FR';
import localegswLI from '@angular/common/locales/gsw-LI';
import localegsw from '@angular/common/locales/gsw';
import localegu from '@angular/common/locales/gu';
import localeguz from '@angular/common/locales/guz';
import localegv from '@angular/common/locales/gv';
import localehaGH from '@angular/common/locales/ha-GH';
import localehaNE from '@angular/common/locales/ha-NE';
import localeha from '@angular/common/locales/ha';
import localehaw from '@angular/common/locales/haw';
import localehe from '@angular/common/locales/he';
import localehi from '@angular/common/locales/hi';
import localehrBA from '@angular/common/locales/hr-BA';
import localehr from '@angular/common/locales/hr';
import localehsb from '@angular/common/locales/hsb';
import localehu from '@angular/common/locales/hu';
import localehy from '@angular/common/locales/hy';
import localeid from '@angular/common/locales/id';
import localeig from '@angular/common/locales/ig';
import localeii from '@angular/common/locales/ii';
import localeis from '@angular/common/locales/is';
import localeitCH from '@angular/common/locales/it-CH';
import localeitSM from '@angular/common/locales/it-SM';
import localeitVA from '@angular/common/locales/it-VA';
import localeit from '@angular/common/locales/it';
import localeja from '@angular/common/locales/ja';
import localejgo from '@angular/common/locales/jgo';
import localejmc from '@angular/common/locales/jmc';
import localeka from '@angular/common/locales/ka';
import localekab from '@angular/common/locales/kab';
import localekam from '@angular/common/locales/kam';
import localekde from '@angular/common/locales/kde';
import localekea from '@angular/common/locales/kea';
import localekhq from '@angular/common/locales/khq';
import localeki from '@angular/common/locales/ki';
import localekk from '@angular/common/locales/kk';
import localekkj from '@angular/common/locales/kkj';
import localekl from '@angular/common/locales/kl';
import localekln from '@angular/common/locales/kln';
import localekm from '@angular/common/locales/km';
import localekn from '@angular/common/locales/kn';
import localekoKP from '@angular/common/locales/ko-KP';
import localeko from '@angular/common/locales/ko';
import localekok from '@angular/common/locales/kok';
import localeks from '@angular/common/locales/ks';
import localeksb from '@angular/common/locales/ksb';
import localeksf from '@angular/common/locales/ksf';
import localeksh from '@angular/common/locales/ksh';
import localekw from '@angular/common/locales/kw';
import localeky from '@angular/common/locales/ky';
import localelag from '@angular/common/locales/lag';
import localelb from '@angular/common/locales/lb';
import localelg from '@angular/common/locales/lg';
import localelkt from '@angular/common/locales/lkt';
import localelnAO from '@angular/common/locales/ln-AO';
import localelnCF from '@angular/common/locales/ln-CF';
import localelnCG from '@angular/common/locales/ln-CG';
import localeln from '@angular/common/locales/ln';
import localelo from '@angular/common/locales/lo';
import localelrcIQ from '@angular/common/locales/lrc-IQ';
import localelrc from '@angular/common/locales/lrc';
import localelt from '@angular/common/locales/lt';
import localelu from '@angular/common/locales/lu';
import localeluo from '@angular/common/locales/luo';
import localeluy from '@angular/common/locales/luy';
import localelv from '@angular/common/locales/lv';
import localemasTZ from '@angular/common/locales/mas-TZ';
import localemas from '@angular/common/locales/mas';
import localemer from '@angular/common/locales/mer';
import localemfe from '@angular/common/locales/mfe';
import localemg from '@angular/common/locales/mg';
import localemgh from '@angular/common/locales/mgh';
import localemgo from '@angular/common/locales/mgo';
import localemk from '@angular/common/locales/mk';
import localeml from '@angular/common/locales/ml';
import localemn from '@angular/common/locales/mn';
import localemr from '@angular/common/locales/mr';
import localemsBN from '@angular/common/locales/ms-BN';
import localemsSG from '@angular/common/locales/ms-SG';
import localems from '@angular/common/locales/ms';
import localemt from '@angular/common/locales/mt';
import localemua from '@angular/common/locales/mua';
import localemy from '@angular/common/locales/my';
import localemzn from '@angular/common/locales/mzn';
import localenaq from '@angular/common/locales/naq';
import localenbSJ from '@angular/common/locales/nb-SJ';
import localenb from '@angular/common/locales/nb';
import localend from '@angular/common/locales/nd';
import localendsNL from '@angular/common/locales/nds-NL';
import localends from '@angular/common/locales/nds';
import localeneIN from '@angular/common/locales/ne-IN';
import localene from '@angular/common/locales/ne';
import localenlAW from '@angular/common/locales/nl-AW';
import localenlBE from '@angular/common/locales/nl-BE';
import localenlBQ from '@angular/common/locales/nl-BQ';
import localenlCW from '@angular/common/locales/nl-CW';
import localenlSR from '@angular/common/locales/nl-SR';
import localenlSX from '@angular/common/locales/nl-SX';
import localenl from '@angular/common/locales/nl';
import localenmg from '@angular/common/locales/nmg';
import localenn from '@angular/common/locales/nn';
import localennh from '@angular/common/locales/nnh';
import localenus from '@angular/common/locales/nus';
import localenyn from '@angular/common/locales/nyn';
import localeomKE from '@angular/common/locales/om-KE';
import localeom from '@angular/common/locales/om';
import localeor from '@angular/common/locales/or';
import localeosRU from '@angular/common/locales/os-RU';
import localeos from '@angular/common/locales/os';
import localepaArab from '@angular/common/locales/pa-Arab';
import localepaGuru from '@angular/common/locales/pa-Guru';
import localepa from '@angular/common/locales/pa';
import localepl from '@angular/common/locales/pl';
import localeps from '@angular/common/locales/ps';
import localeptAO from '@angular/common/locales/pt-AO';
import localeptCH from '@angular/common/locales/pt-CH';
import localeptCV from '@angular/common/locales/pt-CV';
import localeptGQ from '@angular/common/locales/pt-GQ';
import localeptGW from '@angular/common/locales/pt-GW';
import localeptLU from '@angular/common/locales/pt-LU';
import localeptMO from '@angular/common/locales/pt-MO';
import localeptMZ from '@angular/common/locales/pt-MZ';
import localeptPT from '@angular/common/locales/pt-PT';
import localeptST from '@angular/common/locales/pt-ST';
import localeptTL from '@angular/common/locales/pt-TL';
import localept from '@angular/common/locales/pt';
import localequBO from '@angular/common/locales/qu-BO';
import localequEC from '@angular/common/locales/qu-EC';
import localequ from '@angular/common/locales/qu';
import localerm from '@angular/common/locales/rm';
import localern from '@angular/common/locales/rn';
import localeroMD from '@angular/common/locales/ro-MD';
import localero from '@angular/common/locales/ro';
import localerof from '@angular/common/locales/rof';
import localeruBY from '@angular/common/locales/ru-BY';
import localeruKG from '@angular/common/locales/ru-KG';
import localeruKZ from '@angular/common/locales/ru-KZ';
import localeruMD from '@angular/common/locales/ru-MD';
import localeruUA from '@angular/common/locales/ru-UA';
import localeru from '@angular/common/locales/ru';
import localerw from '@angular/common/locales/rw';
import localerwk from '@angular/common/locales/rwk';
import localesah from '@angular/common/locales/sah';
import localesaq from '@angular/common/locales/saq';
import localesbp from '@angular/common/locales/sbp';
import localesd from '@angular/common/locales/sd';
import localeseFI from '@angular/common/locales/se-FI';
import localeseSE from '@angular/common/locales/se-SE';
import localese from '@angular/common/locales/se';
import localeseh from '@angular/common/locales/seh';
import localeses from '@angular/common/locales/ses';
import localesg from '@angular/common/locales/sg';
import localeshiLatn from '@angular/common/locales/shi-Latn';
import localeshiTfng from '@angular/common/locales/shi-Tfng';
import localeshi from '@angular/common/locales/shi';
import localesi from '@angular/common/locales/si';
import localesk from '@angular/common/locales/sk';
import localesl from '@angular/common/locales/sl';
import localesmn from '@angular/common/locales/smn';
import localesn from '@angular/common/locales/sn';
import localesoDJ from '@angular/common/locales/so-DJ';
import localesoET from '@angular/common/locales/so-ET';
import localesoKE from '@angular/common/locales/so-KE';
import localeso from '@angular/common/locales/so';
import localesqMK from '@angular/common/locales/sq-MK';
import localesqXK from '@angular/common/locales/sq-XK';
import localesq from '@angular/common/locales/sq';
import localesrCyrlBA from '@angular/common/locales/sr-Cyrl-BA';
import localesrCyrlME from '@angular/common/locales/sr-Cyrl-ME';
import localesrCyrlXK from '@angular/common/locales/sr-Cyrl-XK';
import localesrCyrl from '@angular/common/locales/sr-Cyrl';
import localesrLatnBA from '@angular/common/locales/sr-Latn-BA';
import localesrLatnME from '@angular/common/locales/sr-Latn-ME';
import localesrLatnXK from '@angular/common/locales/sr-Latn-XK';
import localesrLatn from '@angular/common/locales/sr-Latn';
import localesr from '@angular/common/locales/sr';
import localesvAX from '@angular/common/locales/sv-AX';
import localesvFI from '@angular/common/locales/sv-FI';
import localesv from '@angular/common/locales/sv';
import localeswCD from '@angular/common/locales/sw-CD';
import localeswKE from '@angular/common/locales/sw-KE';
import localeswUG from '@angular/common/locales/sw-UG';
import localesw from '@angular/common/locales/sw';
import localetaLK from '@angular/common/locales/ta-LK';
import localetaMY from '@angular/common/locales/ta-MY';
import localetaSG from '@angular/common/locales/ta-SG';
import localeta from '@angular/common/locales/ta';
import localete from '@angular/common/locales/te';
import localeteoKE from '@angular/common/locales/teo-KE';
import localeteo from '@angular/common/locales/teo';
import localetg from '@angular/common/locales/tg';
import localeth from '@angular/common/locales/th';
import localetiER from '@angular/common/locales/ti-ER';
import localeti from '@angular/common/locales/ti';
import localetk from '@angular/common/locales/tk';
import localeto from '@angular/common/locales/to';
import localetrCY from '@angular/common/locales/tr-CY';
import localetr from '@angular/common/locales/tr';
import localett from '@angular/common/locales/tt';
import localetwq from '@angular/common/locales/twq';
import localetzm from '@angular/common/locales/tzm';
import localeug from '@angular/common/locales/ug';
import localeuk from '@angular/common/locales/uk';
import localeurIN from '@angular/common/locales/ur-IN';
import localeur from '@angular/common/locales/ur';
import localeuzArab from '@angular/common/locales/uz-Arab';
import localeuzCyrl from '@angular/common/locales/uz-Cyrl';
import localeuzLatn from '@angular/common/locales/uz-Latn';
import localeuz from '@angular/common/locales/uz';
import localevaiLatn from '@angular/common/locales/vai-Latn';
import localevaiVaii from '@angular/common/locales/vai-Vaii';
import localevai from '@angular/common/locales/vai';
import localevi from '@angular/common/locales/vi';
import localevun from '@angular/common/locales/vun';
import localewae from '@angular/common/locales/wae';
import localewo from '@angular/common/locales/wo';
import localexog from '@angular/common/locales/xog';
import localeyav from '@angular/common/locales/yav';
import localeyi from '@angular/common/locales/yi';
import localeyoBJ from '@angular/common/locales/yo-BJ';
import localeyo from '@angular/common/locales/yo';
import localeyueHans from '@angular/common/locales/yue-Hans';
import localeyueHant from '@angular/common/locales/yue-Hant';
import localeyue from '@angular/common/locales/yue';
import localezgh from '@angular/common/locales/zgh';
import localezhHansHK from '@angular/common/locales/zh-Hans-HK';
import localezhHansMO from '@angular/common/locales/zh-Hans-MO';
import localezhHansSG from '@angular/common/locales/zh-Hans-SG';
import localezhHans from '@angular/common/locales/zh-Hans';
import localezhHantHK from '@angular/common/locales/zh-Hant-HK';
import localezhHantMO from '@angular/common/locales/zh-Hant-MO';
import localezhHant from '@angular/common/locales/zh-Hant';
import localezh from '@angular/common/locales/zh';
import localezu from '@angular/common/locales/zu';
import {registerLocaleData} from '@angular/common';
import {NgModule} from '@angular/core';

registerLocaleData(localeafNA);
registerLocaleData(localeaf);
registerLocaleData(localeagq);
registerLocaleData(localeak);
registerLocaleData(localeam);
registerLocaleData(localearAE);
registerLocaleData(localearBH);
registerLocaleData(localearDJ);
registerLocaleData(localearDZ);
registerLocaleData(localearEG);
registerLocaleData(localearEH);
registerLocaleData(localearER);
registerLocaleData(localearIL);
registerLocaleData(localearIQ);
registerLocaleData(localearJO);
registerLocaleData(localearKM);
registerLocaleData(localearKW);
registerLocaleData(localearLB);
registerLocaleData(localearLY);
registerLocaleData(localearMA);
registerLocaleData(localearMR);
registerLocaleData(localearOM);
registerLocaleData(localearPS);
registerLocaleData(localearQA);
registerLocaleData(localearSA);
registerLocaleData(localearSD);
registerLocaleData(localearSO);
registerLocaleData(localearSS);
registerLocaleData(localearSY);
registerLocaleData(localearTD);
registerLocaleData(localearTN);
registerLocaleData(localearYE);
registerLocaleData(localear);
registerLocaleData(localeas);
registerLocaleData(localeasa);
registerLocaleData(localeast);
registerLocaleData(localeazCyrl);
registerLocaleData(localeazLatn);
registerLocaleData(localeaz);
registerLocaleData(localebas);
registerLocaleData(localebe);
registerLocaleData(localebem);
registerLocaleData(localebez);
registerLocaleData(localebg);
registerLocaleData(localebm);
registerLocaleData(localebnIN);
registerLocaleData(localebn);
registerLocaleData(localeboIN);
registerLocaleData(localebo);
registerLocaleData(localebr);
registerLocaleData(localebrx);
registerLocaleData(localebsCyrl);
registerLocaleData(localebsLatn);
registerLocaleData(localebs);
registerLocaleData(localecaAD);
registerLocaleData(localecaFR);
registerLocaleData(localecaIT);
registerLocaleData(localeca);
registerLocaleData(localeccpIN);
registerLocaleData(localeccp);
registerLocaleData(localece);
registerLocaleData(localecgg);
registerLocaleData(localechr);
registerLocaleData(localeckbIR);
registerLocaleData(localeckb);
registerLocaleData(localecs);
registerLocaleData(localecy);
registerLocaleData(localedaGL);
registerLocaleData(localeda);
registerLocaleData(localedav);
registerLocaleData(localedeAT);
registerLocaleData(localedeBE);
registerLocaleData(localedeCH);
registerLocaleData(localedeIT);
registerLocaleData(localedeLI);
registerLocaleData(localedeLU);
registerLocaleData(localede);
registerLocaleData(localedje);
registerLocaleData(localedsb);
registerLocaleData(localedua);
registerLocaleData(localedyo);
registerLocaleData(localedz);
registerLocaleData(localeebu);
registerLocaleData(localeeeTG);
registerLocaleData(localeee);
registerLocaleData(localeelCY);
registerLocaleData(localeel);
registerLocaleData(localeen001);
registerLocaleData(localeen150);
registerLocaleData(localeenAG);
registerLocaleData(localeenAI);
registerLocaleData(localeenAS);
registerLocaleData(localeenAT);
registerLocaleData(localeenAU);
registerLocaleData(localeenBB);
registerLocaleData(localeenBE);
registerLocaleData(localeenBI);
registerLocaleData(localeenBM);
registerLocaleData(localeenBS);
registerLocaleData(localeenBW);
registerLocaleData(localeenBZ);
registerLocaleData(localeenCA);
registerLocaleData(localeenCC);
registerLocaleData(localeenCH);
registerLocaleData(localeenCK);
registerLocaleData(localeenCM);
registerLocaleData(localeenCX);
registerLocaleData(localeenCY);
registerLocaleData(localeenDE);
registerLocaleData(localeenDG);
registerLocaleData(localeenDK);
registerLocaleData(localeenDM);
registerLocaleData(localeenER);
registerLocaleData(localeenFI);
registerLocaleData(localeenFJ);
registerLocaleData(localeenFK);
registerLocaleData(localeenFM);
registerLocaleData(localeenGB);
registerLocaleData(localeenGD);
registerLocaleData(localeenGG);
registerLocaleData(localeenGH);
registerLocaleData(localeenGI);
registerLocaleData(localeenGM);
registerLocaleData(localeenGU);
registerLocaleData(localeenGY);
registerLocaleData(localeenHK);
registerLocaleData(localeenIE);
registerLocaleData(localeenIL);
registerLocaleData(localeenIM);
registerLocaleData(localeenIN);
registerLocaleData(localeenIO);
registerLocaleData(localeenJE);
registerLocaleData(localeenJM);
registerLocaleData(localeenKE);
registerLocaleData(localeenKI);
registerLocaleData(localeenKN);
registerLocaleData(localeenKY);
registerLocaleData(localeenLC);
registerLocaleData(localeenLR);
registerLocaleData(localeenLS);
registerLocaleData(localeenMG);
registerLocaleData(localeenMH);
registerLocaleData(localeenMO);
registerLocaleData(localeenMP);
registerLocaleData(localeenMS);
registerLocaleData(localeenMT);
registerLocaleData(localeenMU);
registerLocaleData(localeenMW);
registerLocaleData(localeenMY);
registerLocaleData(localeenNA);
registerLocaleData(localeenNF);
registerLocaleData(localeenNG);
registerLocaleData(localeenNL);
registerLocaleData(localeenNR);
registerLocaleData(localeenNU);
registerLocaleData(localeenNZ);
registerLocaleData(localeenPG);
registerLocaleData(localeenPH);
registerLocaleData(localeenPK);
registerLocaleData(localeenPN);
registerLocaleData(localeenPR);
registerLocaleData(localeenPW);
registerLocaleData(localeenRW);
registerLocaleData(localeenSB);
registerLocaleData(localeenSC);
registerLocaleData(localeenSD);
registerLocaleData(localeenSE);
registerLocaleData(localeenSG);
registerLocaleData(localeenSH);
registerLocaleData(localeenSI);
registerLocaleData(localeenSL);
registerLocaleData(localeenSS);
registerLocaleData(localeenSX);
registerLocaleData(localeenSZ);
registerLocaleData(localeenTC);
registerLocaleData(localeenTK);
registerLocaleData(localeenTO);
registerLocaleData(localeenTT);
registerLocaleData(localeenTV);
registerLocaleData(localeenTZ);
registerLocaleData(localeenUG);
registerLocaleData(localeenUM);
registerLocaleData(localeenVC);
registerLocaleData(localeenVG);
registerLocaleData(localeenVI);
registerLocaleData(localeenVU);
registerLocaleData(localeenWS);
registerLocaleData(localeenZA);
registerLocaleData(localeenZM);
registerLocaleData(localeenZW);
registerLocaleData(localeen);
registerLocaleData(localeeo);
registerLocaleData(localees419);
registerLocaleData(localeesAR);
registerLocaleData(localeesBO);
registerLocaleData(localeesBR);
registerLocaleData(localeesBZ);
registerLocaleData(localeesCL);
registerLocaleData(localeesCO);
registerLocaleData(localeesCR);
registerLocaleData(localeesCU);
registerLocaleData(localeesDO);
registerLocaleData(localeesEA);
registerLocaleData(localeesEC);
registerLocaleData(localeesGQ);
registerLocaleData(localeesGT);
registerLocaleData(localeesHN);
registerLocaleData(localeesIC);
registerLocaleData(localeesMX);
registerLocaleData(localeesNI);
registerLocaleData(localeesPA);
registerLocaleData(localeesPE);
registerLocaleData(localeesPH);
registerLocaleData(localeesPR);
registerLocaleData(localeesPY);
registerLocaleData(localeesSV);
registerLocaleData(localeesUS);
registerLocaleData(localeesUY);
registerLocaleData(localeesVE);
registerLocaleData(localees);
registerLocaleData(localeet);
registerLocaleData(localeeu);
registerLocaleData(localeewo);
registerLocaleData(localefaAF);
registerLocaleData(localefa);
registerLocaleData(localeffCM);
registerLocaleData(localeffGN);
registerLocaleData(localeffMR);
registerLocaleData(localeff);
registerLocaleData(localefi);
registerLocaleData(localefil);
registerLocaleData(localefoDK);
registerLocaleData(localefo);
registerLocaleData(localefrBE);
registerLocaleData(localefrBF);
registerLocaleData(localefrBI);
registerLocaleData(localefrBJ);
registerLocaleData(localefrBL);
registerLocaleData(localefrCA);
registerLocaleData(localefrCD);
registerLocaleData(localefrCF);
registerLocaleData(localefrCG);
registerLocaleData(localefrCH);
registerLocaleData(localefrCI);
registerLocaleData(localefrCM);
registerLocaleData(localefrDJ);
registerLocaleData(localefrDZ);
registerLocaleData(localefrGA);
registerLocaleData(localefrGF);
registerLocaleData(localefrGN);
registerLocaleData(localefrGP);
registerLocaleData(localefrGQ);
registerLocaleData(localefrHT);
registerLocaleData(localefrKM);
registerLocaleData(localefrLU);
registerLocaleData(localefrMA);
registerLocaleData(localefrMC);
registerLocaleData(localefrMF);
registerLocaleData(localefrMG);
registerLocaleData(localefrML);
registerLocaleData(localefrMQ);
registerLocaleData(localefrMR);
registerLocaleData(localefrMU);
registerLocaleData(localefrNC);
registerLocaleData(localefrNE);
registerLocaleData(localefrPF);
registerLocaleData(localefrPM);
registerLocaleData(localefrRE);
registerLocaleData(localefrRW);
registerLocaleData(localefrSC);
registerLocaleData(localefrSN);
registerLocaleData(localefrSY);
registerLocaleData(localefrTD);
registerLocaleData(localefrTG);
registerLocaleData(localefrTN);
registerLocaleData(localefrVU);
registerLocaleData(localefrWF);
registerLocaleData(localefrYT);
registerLocaleData(localefr);
registerLocaleData(localefur);
registerLocaleData(localefy);
registerLocaleData(localega);
registerLocaleData(localegd);
registerLocaleData(localegl);
registerLocaleData(localegswFR);
registerLocaleData(localegswLI);
registerLocaleData(localegsw);
registerLocaleData(localegu);
registerLocaleData(localeguz);
registerLocaleData(localegv);
registerLocaleData(localehaGH);
registerLocaleData(localehaNE);
registerLocaleData(localeha);
registerLocaleData(localehaw);
registerLocaleData(localehe);
registerLocaleData(localehi);
registerLocaleData(localehrBA);
registerLocaleData(localehr);
registerLocaleData(localehsb);
registerLocaleData(localehu);
registerLocaleData(localehy);
registerLocaleData(localeid);
registerLocaleData(localeig);
registerLocaleData(localeii);
registerLocaleData(localeis);
registerLocaleData(localeitCH);
registerLocaleData(localeitSM);
registerLocaleData(localeitVA);
registerLocaleData(localeit);
registerLocaleData(localeja);
registerLocaleData(localejgo);
registerLocaleData(localejmc);
registerLocaleData(localeka);
registerLocaleData(localekab);
registerLocaleData(localekam);
registerLocaleData(localekde);
registerLocaleData(localekea);
registerLocaleData(localekhq);
registerLocaleData(localeki);
registerLocaleData(localekk);
registerLocaleData(localekkj);
registerLocaleData(localekl);
registerLocaleData(localekln);
registerLocaleData(localekm);
registerLocaleData(localekn);
registerLocaleData(localekoKP);
registerLocaleData(localeko);
registerLocaleData(localekok);
registerLocaleData(localeks);
registerLocaleData(localeksb);
registerLocaleData(localeksf);
registerLocaleData(localeksh);
registerLocaleData(localekw);
registerLocaleData(localeky);
registerLocaleData(localelag);
registerLocaleData(localelb);
registerLocaleData(localelg);
registerLocaleData(localelkt);
registerLocaleData(localelnAO);
registerLocaleData(localelnCF);
registerLocaleData(localelnCG);
registerLocaleData(localeln);
registerLocaleData(localelo);
registerLocaleData(localelrcIQ);
registerLocaleData(localelrc);
registerLocaleData(localelt);
registerLocaleData(localelu);
registerLocaleData(localeluo);
registerLocaleData(localeluy);
registerLocaleData(localelv);
registerLocaleData(localemasTZ);
registerLocaleData(localemas);
registerLocaleData(localemer);
registerLocaleData(localemfe);
registerLocaleData(localemg);
registerLocaleData(localemgh);
registerLocaleData(localemgo);
registerLocaleData(localemk);
registerLocaleData(localeml);
registerLocaleData(localemn);
registerLocaleData(localemr);
registerLocaleData(localemsBN);
registerLocaleData(localemsSG);
registerLocaleData(localems);
registerLocaleData(localemt);
registerLocaleData(localemua);
registerLocaleData(localemy);
registerLocaleData(localemzn);
registerLocaleData(localenaq);
registerLocaleData(localenbSJ);
registerLocaleData(localenb);
registerLocaleData(localend);
registerLocaleData(localendsNL);
registerLocaleData(localends);
registerLocaleData(localeneIN);
registerLocaleData(localene);
registerLocaleData(localenlAW);
registerLocaleData(localenlBE);
registerLocaleData(localenlBQ);
registerLocaleData(localenlCW);
registerLocaleData(localenlSR);
registerLocaleData(localenlSX);
registerLocaleData(localenl);
registerLocaleData(localenmg);
registerLocaleData(localenn);
registerLocaleData(localennh);
registerLocaleData(localenus);
registerLocaleData(localenyn);
registerLocaleData(localeomKE);
registerLocaleData(localeom);
registerLocaleData(localeor);
registerLocaleData(localeosRU);
registerLocaleData(localeos);
registerLocaleData(localepaArab);
registerLocaleData(localepaGuru);
registerLocaleData(localepa);
registerLocaleData(localepl);
registerLocaleData(localeps);
registerLocaleData(localeptAO);
registerLocaleData(localeptCH);
registerLocaleData(localeptCV);
registerLocaleData(localeptGQ);
registerLocaleData(localeptGW);
registerLocaleData(localeptLU);
registerLocaleData(localeptMO);
registerLocaleData(localeptMZ);
registerLocaleData(localeptPT);
registerLocaleData(localeptST);
registerLocaleData(localeptTL);
registerLocaleData(localept);
registerLocaleData(localequBO);
registerLocaleData(localequEC);
registerLocaleData(localequ);
registerLocaleData(localerm);
registerLocaleData(localern);
registerLocaleData(localeroMD);
registerLocaleData(localero);
registerLocaleData(localerof);
registerLocaleData(localeruBY);
registerLocaleData(localeruKG);
registerLocaleData(localeruKZ);
registerLocaleData(localeruMD);
registerLocaleData(localeruUA);
registerLocaleData(localeru);
registerLocaleData(localerw);
registerLocaleData(localerwk);
registerLocaleData(localesah);
registerLocaleData(localesaq);
registerLocaleData(localesbp);
registerLocaleData(localesd);
registerLocaleData(localeseFI);
registerLocaleData(localeseSE);
registerLocaleData(localese);
registerLocaleData(localeseh);
registerLocaleData(localeses);
registerLocaleData(localesg);
registerLocaleData(localeshiLatn);
registerLocaleData(localeshiTfng);
registerLocaleData(localeshi);
registerLocaleData(localesi);
registerLocaleData(localesk);
registerLocaleData(localesl);
registerLocaleData(localesmn);
registerLocaleData(localesn);
registerLocaleData(localesoDJ);
registerLocaleData(localesoET);
registerLocaleData(localesoKE);
registerLocaleData(localeso);
registerLocaleData(localesqMK);
registerLocaleData(localesqXK);
registerLocaleData(localesq);
registerLocaleData(localesrCyrlBA);
registerLocaleData(localesrCyrlME);
registerLocaleData(localesrCyrlXK);
registerLocaleData(localesrCyrl);
registerLocaleData(localesrLatnBA);
registerLocaleData(localesrLatnME);
registerLocaleData(localesrLatnXK);
registerLocaleData(localesrLatn);
registerLocaleData(localesr);
registerLocaleData(localesvAX);
registerLocaleData(localesvFI);
registerLocaleData(localesv);
registerLocaleData(localeswCD);
registerLocaleData(localeswKE);
registerLocaleData(localeswUG);
registerLocaleData(localesw);
registerLocaleData(localetaLK);
registerLocaleData(localetaMY);
registerLocaleData(localetaSG);
registerLocaleData(localeta);
registerLocaleData(localete);
registerLocaleData(localeteoKE);
registerLocaleData(localeteo);
registerLocaleData(localetg);
registerLocaleData(localeth);
registerLocaleData(localetiER);
registerLocaleData(localeti);
registerLocaleData(localetk);
registerLocaleData(localeto);
registerLocaleData(localetrCY);
registerLocaleData(localetr);
registerLocaleData(localett);
registerLocaleData(localetwq);
registerLocaleData(localetzm);
registerLocaleData(localeug);
registerLocaleData(localeuk);
registerLocaleData(localeurIN);
registerLocaleData(localeur);
registerLocaleData(localeuzArab);
registerLocaleData(localeuzCyrl);
registerLocaleData(localeuzLatn);
registerLocaleData(localeuz);
registerLocaleData(localevaiLatn);
registerLocaleData(localevaiVaii);
registerLocaleData(localevai);
registerLocaleData(localevi);
registerLocaleData(localevun);
registerLocaleData(localewae);
registerLocaleData(localewo);
registerLocaleData(localexog);
registerLocaleData(localeyav);
registerLocaleData(localeyi);
registerLocaleData(localeyoBJ);
registerLocaleData(localeyo);
registerLocaleData(localeyueHans);
registerLocaleData(localeyueHant);
registerLocaleData(localeyue);
registerLocaleData(localezgh);
registerLocaleData(localezhHansHK);
registerLocaleData(localezhHansMO);
registerLocaleData(localezhHansSG);
registerLocaleData(localezhHans);
registerLocaleData(localezhHantHK);
registerLocaleData(localezhHantMO);
registerLocaleData(localezhHant);
registerLocaleData(localezh);
registerLocaleData(localezu);

@NgModule()
export class LocalesModule {

}
